// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from 'react-router-dom';
import { Login, Join, FindIdPw, LoginModal, Main, MyPage, MyCertificate, Greeting, Intro, Activity, Dept, ArticlesOfIncorporation, ActivityHistory, Event, EventList, MembersIntro, MemberStatistics, MembersSearch, Notice, Honer, MembersNews, Periodical, Community, PromotionBoard, PasswordUri, Policy, Terms, EventBoard, Yehstudy, YehsGroup  } from "./pages";
// Recruitment
// QuestionBoard
// FreeBoard
import { Detail, UserDetail, Board } from "./components";
import Header from './Header';
import Breadcrumb from './Breadcrumb';
import Block from './Block';
import Footer from './Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './ProtectedRoute';
import { isLoginSelector, TokenAtom } from './Recoil/TokenAtom';
import { useRecoilState, useSetRecoilState } from 'recoil';


import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';








const menuSet=[
    {
        idTxt: 'intro', name: 'YEHS 소개', link: '/intro', subMenu: [
            { id:'1', name: '차세대공학리더 소개', link: '/intro' },
            { id:'2', name: '인사말/비전', link: '/greeting' },
            { id:'3', name: '주요 활동', link: '/activity' },
            { id:'4', name: '활동연혁', link: '/activityHistory' },
            { id:'5', name: '조직구성', link: '/dept' },
            { id:'6', name: '차세대공학리더 정관', link: '/articlesOfIncorporation' },
        ]
    },

    {
        idTxt: 'event', name: '행사', link: '/event', subMenu: [
            { id:'1', name: '행사접수', link: '/event' },
            { id:'2', name: '행사정리', link: '/eventList' },
        ]
    },

    {
        idTxt: 'member', name: '회원', link: '/membersintro', subMenu: [
            { id:'1', name: '회원소개', link: '/membersintro' },
            { id:'2', name: '회원검색', link: '/membersSearch' },
            // { id:'3', name: '회원통계', link: '/memberStatistics' },
        ]
    },

    {
        idTxt: 'news', name: 'YEHS 소식', link: '/notice', subMenu: [
            { id:'1', name: '공지사항', link: '/notice' },
            { id:'2', name: '정기간행물', link: '/periodical' },
            { id:'3', name: '명예의 전당', link: '/honer' },
            { id:'4', name: '회원동정', link: '/membersNews' },
        ]
    },

    {
        idTxt: 'community', name: '커뮤니티', link: '/community', subMenu: [
            { id:'1', name: '커뮤니티', link: '/community' },
            // { id:'2', name: '회원모집', link: '/recruitment' },
            { id:'6', name: '행사 캘린더', link: '/eventBoard' },
            // { id:'3', name: '질문게시판', link: '/questionBoard' },
            { id:'4', name: '홍보게시판', link: '/promotionBoard' },
            // { id:'5', name: '자유게시판', link: '/freeBoard' },
            { id:'7', name: 'YEHStudy', link: '/yehstudy' },
            { id:'8', name: 'YEHS 소모임', link: '/yehsGroup' },
        ]
    },
];

function Layout({ openLoginModal }) {
    return (
        <>
            <Header openLoginModal={openLoginModal} menuSet={menuSet} />
            <Breadcrumb menuSet={menuSet} />
            <Outlet />
            <Footer />
        </>
    );
}

function AppContent() {
    const [isLogin, setIsLogin] = useRecoilState(isLoginSelector);
    const setAccessToken = useSetRecoilState(TokenAtom);
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);

    const openLoginModal = () => {
        setLoginModalOpen(true);
    };

    const closeLoginModal = () => {
        setLoginModalOpen(false);
    };

    const location = useLocation();

    useEffect(() => {
        const token = sessionStorage.getItem('accessToken');
        if (token) {
            setAccessToken(token);
        }
    }, [setAccessToken]);

    useEffect(() => {
        if (isLoginModalOpen && isLogin) {
            closeLoginModal();
        }
    }, [isLogin, isLoginModalOpen]);

    return (
        <div className="App">
            <Routes>
                <Route path="/*" element={<Block />} />
                <Route element={<Layout openLoginModal={openLoginModal} />}>
                    <Route path="/" element={<Main />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/join" element={<Join />} />
                    <Route path="/findIdPw" element={<FindIdPw />} />
                    <Route path="/noticedetail" element={<Detail />} />
                    <Route path="/userdetail" element={<UserDetail />} />
                    <Route path="/board" element={<Board />} />
                    <Route path="/passwordUri" element={<PasswordUri />} />


                    <Route path="/terms" element={<Terms />} />
                    <Route path="/policy" element={<Policy />} />

                    {/* YEHS 소개 */}
                    <Route path="/intro" element={<Intro />} /> 
                    <Route path="/greeting" element={<Greeting />} />
                    <Route path="/activity" element={<Activity />} />
                    <Route path="/activityHistory" element={<ActivityHistory />} />
                    <Route path="/dept" element={<Dept />} />
                    <Route path="/articlesOfIncorporation" element={<ArticlesOfIncorporation />} />

                    {/* 행사 */}
                    <Route path="/event" element={<Event cateIdx={9999} type={'ev'} />} />
                    

                    {/* 회원 */}
                    {isLogin ? (
                        <>
                            <Route path="/eventList" element={<EventList cateIdx={7} type={'do'} />} />
                            <Route path="/membersSearch" element={<MembersSearch />} />
                        </>
                    ) : (
                        <>
                        </>
                    )}
                    
                    <Route path="/membersintro" element={<MembersIntro />} />
                    {/* <Route path="/memberStatistics" element={<MemberStatistics />} /> */}

                    {/* YEHS 소식 */}
                    <Route path="/notice" element={<Notice cateIdx={1} type={'do'} />} />
                    <Route path="/periodical" element={<Periodical cateIdx={2} type={'do'} />} />
                    <Route path="/honer" element={<Honer cateIdx={5} type={'do'} />} />
                    <Route path="/membersnews" element={<MembersNews cateIdx={6} type={'do'} />} />

                    {/* 커뮤니티 */}
                    <Route path="/community" element={<Community />} />
                    {/* <Route path="/recruitment" element={<Recruitment cateIdx={10} type={'do'} />} /> */}
                    <Route path="/eventBoard" element={<EventBoard cateIdx={12} type={'do'} />} />
                    {/* <Route path="/questionBoard" element={<QuestionBoard cateIdx={8} type={'do'} />} /> */}
                    <Route path="/promotionBoard" element={<PromotionBoard cateIdx={3} type={'do'} />} />
                    {/* <Route path="/freeBoard" element={<FreeBoard cateIdx={9} type={'do'} />} /> */}
                    <Route path="/yehstudy" element={<Yehstudy cateIdx={13} type={'do'} />} />
                    <Route path="/yehsGroup" element={<YehsGroup cateIdx={14} type={'do'} />} />









                    




                    {/* 회원전용 */}
                    <Route element={<ProtectedRoute />}>
                        <Route path="/membersSearch" element={<MembersSearch />} />
                        <Route path="/eventList" element={<EventList />} />
                        <Route path="/mypage" element={<MyPage />} />
                        <Route path="/mycertificate" element={<MyCertificate />} />
                    </Route>
                </Route>
            </Routes>
            {isLoginModalOpen && <LoginModal closeLoginModal={closeLoginModal} />}
        </div>
    );
}

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router>
                    <AppContent />
                    <ToastContainer
                        position="bottom-center" // 알람 위치 지정
                        autoClose={3000} // 자동 off 시간
                        hideProgressBar={true} // 진행시간바 숨김
                        closeOnClick // 클릭으로 알람 닫기
                        rtl={false} // 알림 좌우 반전
                        pauseOnFocusLoss // 화면을 벗어나면 알람 정지
                        draggable // 드래그 가능
                        pauseOnHover // 마우스를 올리면 알람 정지
                        theme="dark"
                    />
                </Router>
            </PersistGate>
        </Provider>
        
    );
}

export default App;